export default "__VITE_ASSET__b7fc07c2__"